import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react';

import { HotestPropertiesSection } from '@app/components/home/HotestPropertiesSection';
import { MainHero } from '@app/components/home/MainHero';
import { MobileApp } from '@app/components/home/MobileApp';
import { PartnerSection } from '@app/components/home/PartnerSection';
import { PropertiesSection } from '@app/components/home/PropertiesSection';
import { SearchSection } from '@app/components/home/SearchSection';
import { ServicesSection } from '@app/components/home/ServicesSection';
import { WhoWeAreSection } from '@app/components/home/WhoWeAreSection';
import { useHeadMeta } from '@app/hooks/useHeadMeta';
import { newsService } from '@app/services/portal/news.services';
import { withLayout } from '@components/withLayout';

export const getServerSideProps: GetServerSideProps = async ctx => {
  try {
    const newsResponse = await newsService
      .setServerContext(ctx.req, ctx.res)
      .setCookies(ctx.req.headers.cookie || '')
      .list({
        pageIndex: 1,
        pageSize: 12,
      });

    const statisticResponse = await newsService
      .setServerContext(ctx.req, ctx.res)
      .setCookies(ctx.req.headers.cookie || '')
      .statistic();

    return {
      props: {
        news: newsResponse.data,
        statistic: statisticResponse.data,
      },
    };
  } catch {
    return {
      props: {
        news: [],
        statistic: [],
      },
    };
  }
};

const HomePage: React.FC<{ news: any; statistic: any }> = ({ news, statistic }) => {
  const { setTitle, setDescription, setKeywords } = useHeadMeta();
  useEffect(() => {
    setTitle('Trang chủ');
    setDescription('Trang chủ');
    setKeywords('Trang chủ');
  }, [setTitle, setDescription, setKeywords]);

  return (
    <>
      <MainHero />
      <SearchSection className="sticky bottom-0 z-100 2xl:bottom-5 transition-all" />
      <PropertiesSection properties={news} />
      <ServicesSection />
      <WhoWeAreSection />
      {statistic?.length && <HotestPropertiesSection properties={statistic} />}
      <MobileApp />
      <PartnerSection />
    </>
  );
};

export default withLayout(HomePage);
